import type { FC } from "react";
import React from "react";
import { Button, Flex, Heading } from "@edreamsodigeo/prisma-design-system";
import { Trans, useTranslation } from "@edreamsodigeo/frontend-core";

import { FareCard } from "~/components/common/FareCard/FareCard";
import type { DualPriceContainerTemplateProps } from "../contract";
import { StyledPrice } from "~/components/common/StyledPrice";
import { PrimePriceDisclaimer } from "~/components/engage/DualPriceStickyBar/components/PrimePriceDisclaimer";

export const DefaultDualPriceContainerTemplate: FC<
  DualPriceContainerTemplateProps
> = ({
  offer,
  discountedPricePerPassenger,
  nonDiscountedPricePerPassenger,
  savings,
  onContinueWithDiscount,
  onContinueWithoutDiscount,
}) => {
  const { t } = useTranslation();

  return (
    <Flex
      flexDirection={"column"}
      gap={"big"}
      padding={"base"}
      backgroundColor={"neutral.10"}
    >
      <Heading type={"2"} weight={"medium"}>
        {t("prime.dualPriceMobile.selectFare")}
      </Heading>
      <FareCard
        type={"secondary"}
        fareTitle={t("prime.dualPriceMobile.nonDiscounted.title")}
        farePrice={nonDiscountedPricePerPassenger}
        farePriceDescription={t("variables.price.perPaxLabel")}
      >
        <Button
          type={"secondary"}
          onClick={onContinueWithoutDiscount}
          fullWidth
        >
          {t("prime.dualPriceMobile.nonDiscounted.cta")}
        </Button>
      </FareCard>
      <FareCard
        fareTitle={t("prime.dualPriceMobile.discounted.title")}
        pillLabel={
          <Trans
            i18nKey={"prime.dualPriceMobile.discounted.savingLabel"}
            components={{
              savingAmount: <StyledPrice money={savings} rounded />,
            }}
          />
        }
        fareDiscountedPrice={discountedPricePerPassenger}
        farePrice={nonDiscountedPricePerPassenger}
        fareSubtitle={<PrimePriceDisclaimer offer={offer} savings={savings} />}
        farePriceDescription={t("variables.price.perPaxLabel")}
      >
        <Button onClick={onContinueWithDiscount} fullWidth>
          {t("prime.dualPriceMobile.discounted.cta")}
        </Button>
      </FareCard>
    </Flex>
  );
};
